<template>
  <div class="w-full px-4 lg:px-10 pb-20 pt-10 lg:pt-0 lg:pb-0 justify-start items-start">
        <div class="font-mono font-normal mb-14 lg:mb-0  w-full lg:w-auto text-right">
      <p class="relative mix-blend-difference text-white text-14 -z-1 font-unionregular xl:whitespace-nowrap">{{$t('testo-footer')}}</p>
     <p><NuxtLink to="https://firenzeformacontinua.it" target="_blank" class="-mt-5 underline text-white mix-blend-difference font-unionregular">firenzeformacontinua.it</NuxtLink></p>
    </div>
  <div class="w-full flex flex-col lg:flex-row lg:justify-between pb-20 pt-20 lg:pt-0 lg:pb-0">

    <div class="flex-1 w-full flex flex-col flex-wrap lg:flex-row lg:space-y-4 2xl:space-y-0 space-y-10 mix-blend-difference items-start lg:items-center mb-20">

      <div class="flex flex-col lg:flex-row lg:space-x-2 space-y-2 lg:space-y-0 items-start lg:items-center lg:mr-12">
        <p class="text-10 font-unionregular whitespace-nowrap pr-5">Progetto finanziato a valere sui fondi Legge 20 febbraio 2006, n. 77<br> "Misure speciali di tutela e fruizione dei siti e degli elementi italiani di interesse<br> culturale, paesaggistico e ambientale, inseriti nella "lista del patrimonio mondiale",<br> posti sotto la tutela dell'UNESCO
        </p>
        <img src="/assets/images/mic-nero.svg" class="inline-block  h-9 mix-blend-difference lg:mr-12">
      </div>
            <img src="/assets/images/comune-firenze.svg" class="inline-block h-11 invert mix-blend-difference lg:mr-12">
      <img src="/assets/images/firenze-patrimonio-mondiale.svg" class="inline-block  h-8 invert lg:mr-12">
      <img src="/assets/images/unifi-bianco.svg" class="inline-block h-10 lg:mr-12">
      <img src="/assets/images/here.svg" class="inline-block h-5 invert">
    </div>
  </div>
  </div>
</template>